import { css } from 'emotion'

export const marginRightSmallestStyles = css`
  margin-right: 4px;
`
